import { Role } from '../services';
import { ProjectSourceFilter, PortfolioAttachmentTransformation } from '../../gql-operations/gql-generated';

export const getPortfolioModalSellerDataQueryKey = (username: string) =>
    ['portfolio_modal_seller_data', username] as const;

export const getPortfolioModalProjectDataQueryKey = ({
    username,
    projectId,
    cardTransformation,
}: {
    username: string;
    projectId?: string;
    cardTransformation?: PortfolioAttachmentTransformation;
}) => ['portfolio_modal_project_data', username, projectId, cardTransformation] as const;

export const getPortfolioWidgetFullDataQueryKey = ({
    username,
    roleIds,
    roles,
    projectSource,
    limit,
}: {
    username: string;
    roleIds?: string[];
    roles?: Role[];
    projectSource?: ProjectSourceFilter;
    limit?: number;
}) => ['portfolio_widget_full_data', roleIds, username, roles, projectSource, limit] as const;
